import { createSlice } from "@reduxjs/toolkit";


export const appSlice = createSlice({
    name: 'appSlice',//변경해도 의미 없네 (내부적으로 식별 용도인 듯)
    initialState: {   

        isAdmin: false,
        isLoggedIn: false,
        userInfo: {},
        selectedManualIndex: 0,

    },
    
    reducers: {

        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload;
        },
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setSelectedManualIndex: (state, action) => {
            state.selectedManualIndex = action.payload;
        },
    

    }


});



export const { 
    setIsAdmin,
    setIsLoggedIn,
    setUserInfo,
    setSelectedManualIndex,

} = appSlice.actions;

export default appSlice.reducer;

